import React from "react";

export default React.createContext({
    productsFromAPI:{},
    getDatafromAPI: (offset,page,searchsort) =>{},
    cartQuantity:0,
    getCartQuantity:() =>{},
    toogleShow:false,
    changeToogleShow:(bool)=>{},
    addedQuantity:0,
    changeAddedQuantity:(qte)=>{}
});